import React from 'react';
import Schema from '../../Schema/Schema';

const ItemListSchema = (props: { items: any }) => {
	const { items } = props;
	return (
		<Schema
			schema={{
				'@context': 'http://schema.org',
				'@type': 'ItemList',
				itemListElement: [
					...items.map((item: any, index: number) => ({
						'@type': 'ListItem',
						position: `${index + 1}`,
						...item,
					})),
				],
			}}
		/>
	);
};

export default ItemListSchema;
